/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import color from '@deprecated-ui/_style/color';
import Link from 'next/link';
import If from 'global/Common/If';
import CorpActionTag from './CorpActionTag';
import { BarWrapper, IconArrow } from './styled';

interface CorpActionBarProps {
  symbol: string;
  corpAction: Record<string, any>;
  isGuestCompanyStock?: boolean;
  onClick?: (...args) => void;
  typeCompany?: string;
}

function CorpActionBar({
  symbol,
  corpAction,
  isGuestCompanyStock = false,
  onClick,
  typeCompany = '',
}: CorpActionBarProps) {
  const onClickLink = (event) => (isGuestCompanyStock ? onClick(event) : false);
  const formatComma = (number: number) =>
    new Intl.NumberFormat('en-US').format(number);
  const getPriceText = () => {
    if (typeCompany.toLowerCase() === 'waran') return 'Exercise Price';
    if (typeCompany.toLowerCase() === 'right') return 'Right Issue Price';
    return '';
  };
  const renderText = () => {
    if (corpAction.detail) {
      if (
        typeCompany.toLowerCase() === 'waran' ||
        typeCompany.toLowerCase() === 'right'
      ) {
        return (
          <>
            {/* @ts-expect-error */}
            <Text
              as="span"
              color={color.highempahis}
              weight="600"
              ml="8px"
              size="12px"
            >
              {getPriceText()}: {formatComma(corpAction.detail?.price)} •{' '}
              <span style={{ fontWeight: 400 }}>
                Trading End: {corpAction.detail?.trading_end_date?.formatted}{' '}
                <If condition={typeCompany.toLowerCase() === 'waran'}>
                  • Exercise End:{' '}
                  {corpAction.detail?.exercise_end_date?.formatted}
                </If>
              </span>
            </Text>
          </>
        );
      }
    }
    return (
      <>
        {/* @ts-expect-error */}
        <Text
          as="span"
          color={color.highempahis}
          weight="600"
          ml="8px"
          size="12px"
        >
          Perusahaan memiliki Corporate Action
        </Text>
      </>
    );
  };
  return (
    <Link href={`/symbol/${symbol}/corpaction`} passHref onClick={onClickLink}>
      <a>
        <BarWrapper>
          <Flex align="center">
            <CorpActionTag corpAction={corpAction} />
            {renderText()}
          </Flex>
          <IconArrow as="span" />
        </BarWrapper>
      </a>
    </Link>
  );
}

export default CorpActionBar;
